module.exports = __webpack_public_path__ + "img/logovetrex-svg.61a77b6e.svg";